import React from "react";
import PropTypes from "prop-types";
import Markdown from "../Markdown";
import styles from "./style.module.scss";
import Pagination from "../BlogPagination";
import { H1 } from "../Type";
import { LongDate } from "../Dates";

const BlogPost = ({ post, prev, next }) => {
  return (
    <div className={styles.blogPost}>
      <div className={styles.heading}>
        <H1>{post.title}</H1>
        <div className={styles.date}>
          <LongDate date={post.publishAt} />
        </div>
      </div>
      <div className={styles.content}>
        <Markdown html={post.body.markdown.html} />
      </div>
      <Pagination prev={prev} next={next} />
    </div>
  );
};

BlogPost.propTypes = {
  post: PropTypes.shape({
    title: PropTypes.string,
    publishAt: PropTypes.string,
    body: PropTypes.shape({
      body: PropTypes.string
    })
  }).isRequired,
  next: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string
  }),
  prev: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string
  })
};

BlogPost.defaultProps = {
  next: null,
  prev: null
};

export default BlogPost;
